import { useQuoteApiServicePutApiQuoteApiLanguage } from "../../../openapi/api/queries/queries";
import { LanguageInit } from "../../../tools/helper";
import { LanguageSelect } from "../LanguageSelect/LanguageSelect";

import { JSX, useEffect, useState } from "react";

import { useLanguage } from "@4pace-cpq/core";

export function LanguageSelectContainer(): JSX.Element {
  const { setLanguageById, languages } = useLanguage();
  const { mutate: setLanguage } = useQuoteApiServicePutApiQuoteApiLanguage({});

  const language = LanguageInit();

  const [languageId, setLanguageId] = useState<string | undefined>(
    language?.id,
  );

  useEffect(() => {
    setLanguageId(language?.id);
    localStorage.setItem("selectedLanguageId", language?.languageCode ?? "");
    //setLanguage({ requestBody: language?.languageCode?.split("-")[0] });
  }, [language, setLanguage]);

  function handleLanguageChange(languageId: string | undefined): void {
    const languageData = languages.find((lang) => lang.id === languageId);
    const languageCode = languageData?.languageCode;

    localStorage.setItem(
      "selectedLanguageId",
      languageCode ? languageCode : "",
    );

    setLanguageById(languageId);
    if (languageData?.languageCode?.split("-")[0]) {
      setLanguageId(languageData?.id);
    }
  }

  return (
    languages && (
      <LanguageSelect
        languages={languages}
        selectedLanguageId={languageId}
        onChange={(selectedLanguageId) => {
          handleLanguageChange(selectedLanguageId);
        }}
      />
    )
  );
}

export default LanguageSelectContainer;
